import i18n from 'i18next';

export const columns = [
  {
    id: 'event_type',
    numeric: false,
    disablePadding: false,
    label: i18n.t('cameraEvents.event_type'),
    needSorting: true,
  },
  {
    id: 'count',
    numeric: false,
    disablePadding: false,
    label: i18n.t('cameraEvents.event_count'),
    needSorting: true,
  },
  {
    id: 'last_occurence',
    numeric: false,
    disablePadding: false,
    label: i18n.t('cameraEvents.last_occurrence'),
    needSorting: true,
  },
];

export const sortColumnMapping = {
  event_type: 'eventType',
  count: 'eventCount',
  last_occurence: 'lastOccurrenceTime',
};

export const basicRequest = {
  displayStart: 1,
  displayLength: 10,
};
